import script from "./MovingTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./MovingTooltip.vue?vue&type=script&setup=true&lang=js"

import "./MovingTooltip.vue?vue&type=style&index=0&id=95bfec4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95bfec4a"]])

export default __exports__